import React from 'react'
import t from 'prop-types'

class BotoneraIndice extends React.Component {
    static propTypes = {
        libroId: t.string.isRequired,
        configIndice: t.shape({
            textoAtras: t.string.isRequired,
            textoContinuar: t.string.isRequired
        }).isRequired,

        onAtras: t.func.isRequired,
        onContinuar: t.func.isRequired
    }

    // renderExtras () {
    //     const { configIndice, onEntrada } = this.props

    //     return configIndice.extrasBotonera.map( (entrada, index) => {
    //         return <Entrada key={`entrada-extra-botonera-index-${index}`} {...entrada} onClick={ () => onEntrada(entrada, index) } />
    //     })
    // }

    render () {
        const { configIndice, onContinuar, onAtras } = this.props
        const { textoAtras, textoContinuar } = configIndice 
        return (
            <div className="botoneraIndice">
                <div className="botonPasoAdelante" onClick={ () => onContinuar() }>{ textoContinuar }</div>
                {' '}
                {/* { extrasBotonera && this.renderExtras() } */}
                {/* { React.Children.map(this.props.children, (child) => React.cloneElement(child, {...this.props} ) )} */}
                <div className="volverAMenu" onClick={ onAtras } dangerouslySetInnerHTML={{__html: textoAtras }} />
            </div>
        )
    }
}

export default BotoneraIndice    